var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2829 18.875C11.0757 18.875 10.877 18.7927 10.7305 18.6462C10.584 18.4997 10.5017 18.301 10.5017 18.0938C10.5017 17.8866 10.584 17.6878 10.7305 17.5413C10.877 17.3948 11.0757 17.3125 11.2829 17.3125C13.0326 17.3128 14.7316 16.7257 16.1079 15.6454C17.4842 14.5651 18.458 13.0541 18.8733 11.3545C19.2887 9.65489 19.1214 7.86505 18.3985 6.27178C17.6755 4.67851 16.4386 3.37404 14.8861 2.56738C13.3335 1.76073 11.5551 1.49858 9.83577 1.82294C8.11647 2.14731 6.55582 3.03941 5.40388 4.35631C4.25193 5.67321 3.57538 7.33867 3.48263 9.08584C3.38987 10.833 3.88628 12.5607 4.89232 13.9922C5.01093 14.1612 5.05779 14.3704 5.02265 14.5739C4.98752 14.7773 4.87325 14.9587 4.70482 15.0781C4.62085 15.1381 4.52584 15.1808 4.42527 15.2038C4.32469 15.2269 4.22056 15.2298 4.11887 15.2123C4.01718 15.1949 3.91995 15.1575 3.83279 15.1023C3.74563 15.0471 3.67028 14.9751 3.61107 14.8906C2.4039 13.173 1.80821 11.0999 1.91942 9.00339C2.03063 6.90692 2.84231 4.90845 4.22442 3.32816C5.60654 1.74787 7.47908 0.677221 9.54206 0.287748C11.605 -0.101724 13.739 0.21252 15.6022 1.18014C17.4653 2.14775 18.9497 3.71274 19.8176 5.62436C20.6856 7.53598 20.8867 9.68359 20.3889 11.7231C19.891 13.7627 18.723 15.5761 17.072 16.8728C15.4209 18.1696 13.3824 18.8746 11.2829 18.875V18.875Z",
    fill: "white",
    fillOpacity: 0.91
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03125 15.75H1.125C0.9178 15.75 0.719086 15.6677 0.572573 15.5212C0.42606 15.3747 0.34375 15.176 0.34375 14.9688C0.34375 14.7615 0.42606 14.5628 0.572573 14.4163C0.719086 14.2698 0.9178 14.1875 1.125 14.1875H4.25V11.0625C4.25 10.8553 4.33231 10.6566 4.47882 10.5101C4.62534 10.3636 4.82405 10.2812 5.03125 10.2812C5.23845 10.2812 5.43716 10.3636 5.58368 10.5101C5.73019 10.6566 5.8125 10.8553 5.8125 11.0625V14.9688C5.8125 15.176 5.73019 15.3747 5.58368 15.5212C5.43716 15.6677 5.23845 15.75 5.03125 15.75Z",
    fill: "white",
    fillOpacity: 0.91
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93812 12.625C8.83531 12.6256 8.73338 12.6059 8.6382 12.567C8.54301 12.5281 8.45644 12.4708 8.38344 12.3984C8.31021 12.3258 8.25209 12.2394 8.21243 12.1442C8.17276 12.049 8.15234 11.9469 8.15234 11.8438C8.15234 11.7406 8.17276 11.6385 8.21243 11.5433C8.25209 11.4481 8.31021 11.3617 8.38344 11.2891L10.5006 9.17969V5.59375C10.5006 5.38655 10.5829 5.18784 10.7294 5.04132C10.876 4.89481 11.0747 4.8125 11.2819 4.8125C11.4891 4.8125 11.6878 4.89481 11.8343 5.04132C11.9808 5.18784 12.0631 5.38655 12.0631 5.59375V9.5C12.0637 9.60282 12.044 9.70474 12.0051 9.79993C11.9663 9.89511 11.909 9.98169 11.8366 10.0547L9.49281 12.3984C9.41981 12.4708 9.33324 12.5281 9.23805 12.567C9.14286 12.6059 9.04094 12.6256 8.93812 12.625Z",
    fill: "white",
    fillOpacity: 0.91
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_paint",
    x1: 3.90479,
    y1: 13.125,
    x2: 22.6548,
    y2: 13.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4050_33036",
    x1: 2.34375,
    y1: 16.1979,
    x2: 7.8125,
    y2: 16.1979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4050_33036",
    x1: 10.1519,
    y1: 11.9792,
    x2: 14.0626,
    y2: 11.9792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4050_33036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.be2f15667e5eb092faba210b84160cab.svg";
export { ForwardRef as ReactComponent };